import React, { useState } from 'react';
import { Typography, Button, Box, IconButton, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomDialog from '../commoncomponents/CustomDialog';
import { checkFormSubmitForVendor, clearWebForm } from '../../redux/actions/vendor/webFormActions';
import { useDispatch } from 'react-redux';

const BottomButtonForVendorForm = ({
  page = '',
  buttonAttributes,
  enableAuthorizeButton = false,
  saveButton = false,
  saveClick,
  authorizeButton = false,
  authorizeClick,
  continueButton = true,
  disableSave = false
}) => {
  const dispatch = useDispatch();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const findPageName = buttonAttributes.find((item) => item.currentPageName === page) || {};
  const { setPage, cancelButtonName, continueButtonName, backButtonName, backButton, previousPageName, cancelWO } = findPageName;


  const handleCloseCancelDialog = () => {
    setShowDeleteDialog(false);
  };

  const handleConfirmCancel = async () => {
    dispatch(clearWebForm("CLEAR_WEB_FORM", {}));
    dispatch(checkFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", ""));
    setShowDeleteDialog(false);
    window.close();
  };

  const handleBackClick = () => {
    setPage(previousPageName);
  };

  const handleCancelClick = (e) => {
    setShowDeleteDialog(true);
  };

  return (
    <>
      <Stack
        pt={{ xs: 3, md: 8 }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ flexWrap: 'nowrap', width: '100%' }}
      >
        {backButton && (
          <Stack direction="row" alignItems="center" gap={1}>
            <IconButton aria-label="previous" onClick={handleBackClick}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="label" color="text.primary">
              {backButtonName}
            </Typography>
          </Stack>
        )}

        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Stack direction="row" spacing={2}>
            <Button variant="outlined" onClick={handleCancelClick} name="cancel">
              {cancelButtonName}
            </Button>
            {saveButton && (
              <Button variant="contained" onClick={saveClick} disabled={disableSave}>
                Save
              </Button>
            )}
            {authorizeButton ? (
              <Button variant="contained" disabled={enableAuthorizeButton} onClick={authorizeClick}>
                {continueButtonName}
              </Button>
            ) : continueButton ? (
              <Button variant="contained" disabled={enableAuthorizeButton} type="submit">
                {continueButtonName}
              </Button>
            ) : null}
          </Stack>
        </Box>

      </Stack>


      <CustomDialog
        open={showDeleteDialog}
        onClose={handleCloseCancelDialog}
        onConfirm={() => { handleConfirmCancel() }}
        content="Are you sure you want to cancel?"
        cancelBtn="No"
        confirmBtn="Yes"
      />

    </>
  );
};

export default BottomButtonForVendorForm;
